import { Card, Typography, Stack, Button, Collapse } from "@mui/material";
import {
  colors,
  spacing,
  typography,
} from "../../../../../../../../../assets/styles/tokens";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React from "react";
import { Box } from "@mui/system";
import BudgetControlGraphMoreMetrics from "./BudgetControlGraphMoreMetrics";

// ─────────────────────────────────────────────────────────────────────────────

//type StatusColor = "success" | "error";

interface BudgetControlGraphItemCardProps {
  qftd: string;
  qftd_status: string;
  qftd_percentage: string;
  budget_dollar: string;
  budget_status: string;
  budget_percentage: string;
  rr_budget_status: string;
  rr_budget_percentage: string;
  remaining_qftd: string;
  cpa_income_dollar: string;
  total_income_dollar: string;
  cpa_budget_dollar: string;
  ftd: string;
}

export function BudgetControlGraphItemCard({
  qftd,
  qftd_status,
  qftd_percentage,
  budget_dollar,
  budget_status,
  budget_percentage,
  rr_budget_status,
  rr_budget_percentage,
  remaining_qftd,
  cpa_income_dollar,
  total_income_dollar,
  cpa_budget_dollar,
  ftd,
}: BudgetControlGraphItemCardProps) {
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <Card
        sx={{
          boxShadow: "none",
        }}
      >
        <Stack
          mt={spacing.Spacing.sm.$value}
          mb={spacing.Spacing.sm.$value}
          textAlign={"center"}
        >
          <Typography
            variant="body2"
            sx={{
              color: colors.GrayLightMode[900].$value,
            }}
          >
            <Box
              component={"span"}
              sx={{
                fontWeight: typography.Font_weight.Bold.$value,
                fontSize: typography.Size.Text.xl.$value,
                display: "inline-block",
                pr: spacing.Spacing.sm.$value,
              }}
            >
              {budget_percentage}
            </Box>
            of
            <Box
              component={"span"}
              sx={{
                fontWeight: typography.Font_weight.Bold.$value,
                display: "inline-block",
                px: spacing.Spacing.sm.$value,
              }}
            >
              {cpa_budget_dollar}
            </Box>
            total budget used.
          </Typography>
        </Stack>

        <Stack>
          <Button
            size="small"
            onClick={() => setOpen(!open)}
            sx={{
              padding: "0",
              fontSize: typography.Size.Text.xs.$value,
              lineHeight: typography.Line_height.text.xs.$value,
              color: colors.Brand[800].$value,
              fontWeight: typography.Font_weight.Regular.$value,
              textTransform: "capitalize",
              letterSpacing: "0px",
            }}
            data-tracker="654"
          >
            {open ? "Show Less Metrics" : "Show More Metrics"}
            <ExpandMoreIcon
              sx={{
                color: colors.Brand[800].$value,
                transform: open ? "rotate(180deg)" : "rotate(0deg)",
                transition: "0.2s",
              }}
            />
          </Button>

          {/* Expandable Info */}
          <Collapse in={open}>
            <BudgetControlGraphMoreMetrics
              qftd={qftd}
              qftd_status={qftd_status}
              qftd_percentage={qftd_percentage}
              rr_budget_status={rr_budget_status}
              rr_budget_percentage={rr_budget_percentage}
              remaining_qftd={remaining_qftd}
              cpa_income_dollar={cpa_income_dollar}
              total_income_dollar={total_income_dollar}
              cpa_budget_dollar={cpa_budget_dollar}
              ftd={ftd}
              qftd_budget={budget_dollar}
              budget_status={budget_status}
            />
          </Collapse>
        </Stack>
      </Card>
    </>
  );
}
export default BudgetControlGraphItemCard;
